import React, {useEffect, useState} from "react";
import {FormatPrice, FullDate, ShortDate} from "./delivery-tools";
import {
  DELIVERY_AWAITING_LOADING,
  DELIVERY_ENROUTE,
  DELIVERY_LOADING,
  DELIVERY_AGREED,
  DELIVERY_BOOKED
} from "../../helpers/delivery_status.helper";
import {userServices} from "../../services";
import {
  CREATE_AND_FILLED_ORDER,
  SUPPORT_LEGAL_ENTITY_APPROVE,
  UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY, VIEW_FREE_DELIVERIES_LOGIST
} from "../../helpers/user_permission.helper";
import ModalJoinCompany from "../modals/epd-astral/companies";
import {Badge, Icon, Tooltip} from "antd";
import NotificationMessage from "../modals/notification-message";
import {notificationServices} from "../../services/notification.services";
import i18n from "../../i18n";

export function DeliveryOrderInfo({delivery}) {
  const user = userServices.getUser();

  const [isModalJoinCompanyShow, setIsModalJoinCompanyShow] = useState(null);
  const [notifications, setNotifications] = useState(null);

  //Временно скрываю - надо разобраться. В текущей ситуации на каждый рейс по запросу сразу уходит
  //useEffect(() => {
  //  if(!isModalJoinCompanyShow){
  //    notificationServices.getNotifications()
  //      .then((response) => {
  //        setNotifications(response);
  //      })
  //      .catch((errorMsg) => {
  //      })
  //  }
  //}, [isModalJoinCompanyShow]);

  if (delivery.Status === DELIVERY_AWAITING_LOADING || delivery.Status === DELIVERY_ENROUTE || delivery.Status === DELIVERY_LOADING || delivery.Status === DELIVERY_AGREED
    || (user.info.userType === 'inner' && delivery.Status === DELIVERY_BOOKED && delivery.Order != null)) {

    return (
      <>
        <NotificationMessage notifications={notifications} setNeedUpdate={false} setStopListUpdate={()=>{}} loading={isModalJoinCompanyShow} />
        <div className="informer-item pricer">
        <div className="h-informer">{i18n.t('components.tools.deliveryOrderInfo.title')}</div>
          <div className="b-informer">
            <div className="price-line clrfx">
              <div className="ls">{delivery.Order.PaymentType}</div>
              <FormatPrice price={delivery.Order.Price} showPrice={true} currencySymbol={delivery.Order.PaymentSymbol}/>
            </div>
            <div className="price-line clrfx">
            {delivery.IsMultimodal ?
            <div className="ls">{i18n.t('Дата выхода судна')}</div>
            : <div className="ls">{i18n.t('components.tools.deliveryOrderInfo.fields.date.title')}</div>
            }
              <div className="rs">
                <ShortDate date={delivery.Order.Date}/>
                {delivery.hasOwnProperty("LoadingSign") && delivery.LoadingSign !== null && (user.info.userType === 'carrier' || user.isAccessTo(UPLOAD_ADD_PARAMS_ON_LOADING_DELIVERY) || user.isAccessTo(SUPPORT_LEGAL_ENTITY_APPROVE)) ?
                  (<><br/>{delivery.LoadingSign.DateTime.split(' ')[1]}</>) : null
                }
              </div>
            </div>
            {delivery.DriverArrivedTime !== null && user.isAccessTo(VIEW_FREE_DELIVERIES_LOGIST) ?
              <div className="price-line clrfx">
                <div className="ls">{i18n.t('components.tools.deliveryOrderInfo.fields.driverArrivedTime.title')}</div>
                <div className="rs">
                  {delivery.DriverArrivedTime}
                </div>
              </div> : null
            }
            {delivery.ActualLoadTime !== null && user.isAccessTo(VIEW_FREE_DELIVERIES_LOGIST) ?
              <div className="price-line clrfx">
                <div className="ls">{i18n.t('components.tools.deliveryOrderInfo.fields.actualLoadTime.title')}</div>
                <div className="rs">
                  {delivery.ActualLoadTime}
                </div>
              </div> : null
            }
          </div>
        </div>
        {delivery.UseEtrn && user.isAccessTo(CREATE_AND_FILLED_ORDER) ?
          <React.Fragment key={`etrn-button-${delivery.Id}`}>
            <button
              className={`action-button${delivery.EtrnCanAction ? ' action-button-warning' : ''}`}
              onClick={() => setIsModalJoinCompanyShow(delivery.Id)}
            >
              {delivery.EtrnCanAction &&
                <Tooltip placement="top" title={i18n.t('components.tools.deliveryOrderInfo.fields.etrn.tooltip')}>
                  <Icon className='action-button__warning' type="warning" style={{fontSize: '18px'}}/>
                </Tooltip>
              }
              <span>{i18n.t('components.tools.deliveryOrderInfo.fields.etrn.title')}</span>
            </button>
            <ModalJoinCompany onCloseModal={setIsModalJoinCompanyShow} isShow={delivery.Id === isModalJoinCompanyShow}
                              id={delivery.Id}/>
          </React.Fragment>
        : null}
      </>
    );
  }

  return null;
}
